<template>
  <div id="mine">

    <!--<div v-if="isLogin">-->
    <div>
      <div class="mine-header">
        <!--<div class="mine-header-content">-->
        <!--<img src="" id="mine-header-userIcon"/>-->
        <!--</div>-->
        <img :src="userIcon" id="mine-header-userIcon" />
        <div class="mine-header-userContent" >
          <div class="mine-header-userName">{{userName}}</div>
          <div class="mine-header-userLocation">

            <img v-if="locationName.length > 2" src="../../../assets/icon/location.png" class="mine-header-locationImg"/>
            <div class="mine-header-userLocationName">{{locationName}}</div>
          </div>
        </div>
      </div>

      <div id="mine-content">

        <router-link to="/userAccountSet">
          <div class="mine-content-cell mine-content-cell1">
            <div class="mine-content-title">账号设置</div>
          </div>
        </router-link>
        
        <router-link to="/orderManager/0">
          <div class="mine-content-cell mine-content-cell2">
            <div class="mine-content-title">我的订单</div>
          </div>
        </router-link>

        <router-link :to= "{ path: '/addressList', query: { url: '/mine' }}">
          <div class="mine-content-cell mine-content-cell3">
            <div class="mine-content-title">收货地址</div>
          </div>
        </router-link>

        <router-link to="/mine/myBill">
          <div class="mine-content-cell mine-content-cell4">
            <div class="mine-content-title">我的发票</div>
          </div>
        </router-link>

        <router-link to="/aboutBlissMall">
          <div class="mine-content-cell mine-content-cell5">
            <div class="mine-content-title">关于我们</div>
          </div>
        </router-link>

      </div>
    </div>


  </div>
</template>

<script>

import mineLogin from '../../common/login/loginEntrance.vue'
import bus from '../../../js/eventBus'
import api from '../../../api/common/api.common'
import cookieTools from '../../../js/cookie'
  export default {
    name: 'mine',
    data () {
      return {
        userIcon: '',
        locationName: '',
        userName: ''
      }
    },
    components: {
      mineLogin
    },
    mounted () {
      var self = this
      this.userIcon = this.$store.state.user.avatar
      this.userName = this.$store.state.user.nickName
      this.locationName = this.$store.state.user.provinceName + '  ' + this.$store.state.user.cityName
      api.getUserInfo({},function (successRsp) {
        self.$store.dispatch('setUserLogin',successRsp.body.data)
        self.userIcon = self.$store.state.user.avatar
        self.userName = self.$store.state.user.nickName
        self.locationName = self.$store.state.user.provinceName + '  ' + self.$store.state.user.cityName
      },function () {

      },false)

    },
    destroyed () {
    },
    computed: {
      isLogin () {
        return this.utils.isLogin()
      }
    },
    methods: {

    },
    events: {
      'closeMineLogin' : function () {

      }
    }
  }
</script>



<style lang="scss">
  @import '../../../assets/css/mixin';


  .mine-header {
    background: #1B1B1F;
    height: pxToRem(340px);
    /*display: flex;*/
    /*vertical-align: top;*/
  }

  #mine-header-userIcon {
    width: pxToRem(140px);
    height: pxToRem(140px);
    background: #EEEEEE;
    -moz-border-radius: pxToRem(70px);
    -webkit-border-radius: pxToRem(70px);
    border-radius: pxToRem(70px);
    border-width: 0px;

    margin-top: pxToRem(120px);
    margin-left: pxToRem(80px);

    border-color: #000 #000 #000 #000;
  }

  .mine-header-content {
    background-color: #4caf50;
  }
  .mine-header-userContent {
    /*background-color: #4caf50;*/
    display: inline-block;
    /*height: pxToRem(140px);*/
    vertical-align: top;
    height: 100%;

    /*margin-top: 0px;*/
    /*margin-bottom: 0px;*/
  }
  .mine-header-userContent-login {
    margin-top: pxToRem(120px);
    margin-left: pxToRem(40px);
    height: pxToRem(40px);
    background-color: #26a2ff;
    color: white;
  }
  .mine-header-userName {
    margin-top: pxToRem(148px);
    margin-left: pxToRem(40px);

    font-size: pxToRem(30px);
    color: white;
  }
  .mine-header-userLocation {
    /*background-color: white;*/
    height: 50px;
  }
  .mine-header-locationImg {
    margin-left: pxToRem(40px);
    margin-top: pxToRem(16px);
    width: pxToRem(18px);
    height: auto;
    display: inline-block;
    vertical-align: text-bottom;
  }
  .mine-header-userLocationName{
    display: inline-block;
    margin-left: pxToRem(14px);
    margin-top: pxToRem(16px);
    font-size: pxToRem(22px);
    vertical-align: bottom;
    color: white;
  }

  .mine-content-cell {
    margin-top: pxToRem(50px);
    height: pxToRem(70px);
    /*background-color: #4caf50;*/

    /*vertical-align: bottom;*/
  }
  .mine-content-title {
    margin: 0 0 0 pxToRem(80px);
    height: pxToRem(70px);
    line-height: pxToRem(98px);
    font-size: pxToRem(28px);
  }
  .mine-content-cell1 {
    margin-top: pxToRem(60px);
  }
</style>


// WEBPACK FOOTER //
// mine.vue?c8fa1814